import Decimal from 'decimal.js';

export function preciseSum(amounts: number[]) {
  let acc = new Decimal(0);
  for (const amount of amounts) {
    acc = acc.plus(amount);
  }
  return acc.toNumber();
}
